<template>
    <v-col cols="12" md="6" lg="4" class="px-2 mb-2">
      <v-card>
        <v-card-title class="pb-4">
          <v-row no-gutters class="align-center">
            <v-col class="text-truncate">
              <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'title'">Emails</span>
              <v-btn icon @click="showEmailInfo = true">
                <v-icon color="primary">info_outline</v-icon>
              </v-btn>
            </v-col>
            <v-switch class="mt-0" hide-details @change="changeEmailActive" v-model="spaceParams.notify_email" color="primary"/>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-title class="pb-4">
          <v-row no-gutters class="align-center">
            <v-col class="text-truncate">
              <span :class="$vuetify.breakpoint.mdAndDown ? 'text-subtitle-1' : 'title'">SMS</span>
              <v-btn icon @click="showSMSInfo = true">
                <v-icon color="primary">info_outline</v-icon>
              </v-btn>
            </v-col>
            <v-switch class="mt-0" hide-details @change="changeSMSActive" v-model="spaceParams.notify_sms" color="primary"/>
          </v-row>
        </v-card-title>
        <v-card-text v-if="spaceParams.notify_sms" class="pb-1">
          <v-row no-gutters class="mt-2 font-weight-medium">
            <template v-if="spaceParams.sms_available > 0">
              <span class="mx-1">{{spaceParams.sms_available}}</span>
              <span v-translate>SMS available</span>
            </template>
            <span v-else class="red--text font-weight-bold">
              <translate>No SMS available</translate>!
            </span>
          </v-row>
        </v-card-text>
        <v-card-actions v-if="spaceParams.notify_sms">
          <v-spacer></v-spacer>
          <v-btn key="extend" color="primary" text @click="showSMSPricing = true" :disabled="!canBuySMS">
            <translate>Buy</translate>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="showEmailInfo" width="40%">
        <v-card>
          <v-card-title class="primary--text mb-2 secondary">
            Emails
          </v-card-title>
          <v-card-text>
            <p>{{notificationsInfo.email_info}}</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showEmailInfo = false">
              <translate>Close</translate>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showSMSInfo" width="40%">
        <v-card>
          <v-card-title class="primary--text mb-2 secondary">
            SMS
          </v-card-title>
          <v-card-text>
            <p>{{notificationsInfo.sms_info}}</p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showSMSInfo = false">
              <translate>Close</translate>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showSMSPricing" width="450px" scrollable>
        <v-card>
          <v-card-title class="title primary--text secondary">
            <translate>Pricing</translate>
          </v-card-title>
          <v-card-text class="py-3">
            <v-row no-gutters align="center" justify="center" class="mb-2">
              <v-col>
              <v-radio-group v-model="selectedPricingPlan" class="mt-0" hide-details>
                <template v-for="(pricingPlan, i) in smsPlans">
                  <v-radio color="primary" :value="pricingPlan" :key="pricingPlan.id" class="ma-0">
                    <template v-slot:label>
                      <div style="width: 100%">
                        <span>{{pricingPlan.quantity}} SMS</span>
                        <span style="float: right">{{pricingPlan.price}}€</span>
                      </div>
                    </template>
                  </v-radio>
                  <v-divider v-if="i != smsPlans.length - 1" :key="'divider' + pricingPlan.id" class="my-3"></v-divider>
                </template>
              </v-radio-group>
                <v-divider class="my-3"></v-divider>
                <v-row no-gutters class="text-body-1">
                  Total
                  <v-spacer></v-spacer>
                  <span class="font-weight-bold">{{totalPrice}}€</span>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="buySMSNow" :disabled="!canBuyPlan">
              <translate>Buy Now</translate>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
</template>

<script>
import axios from "axios";

export default {
  name: "SMSPlanCard",
  props: ["smsPlans", "notificationsInfo", "spaceParams", "currentSubscriptionPlan"],
  data: () => ({
    showEmailInfo: false,
    showSMSInfo: false,
    showSMSPricing: false,
    selectedPricingPlan: null
  }),
  computed: {
    canBuySMS() {
      return this.currentSubscriptionPlan?.days_left >= 0;
    },
    canBuyPlan() {
      return !!this.selectedPricingPlan;
    },
    totalPrice() {
      return this.selectedPricingPlan?.price || 0;
    }
  },
  methods: {
    buySMSNow() {
      this.$store.dispatch("ADD_ITEM", {
        type: "sms",
        price: this.selectedPricingPlan.price,
        priceWithDiscount: this.selectedPricingPlan.price,
        plan: this.selectedPricingPlan
      });

      this.$router.push({ name: "cart" });
      this.showSMSPricing = false;
    },
    changeEmailActive() {
      axios
        .post("/patient-notifications/notify-email", {'value': this.spaceParams.notify_email})
        .then(response => {
          this.spaceParams.notify_email = response.data.notify_email;
          this.$store.dispatch("EDIT_NOTIFY_EMAIL", response.data.notify_email);
        })
        .catch(() => {});
    },
    changeSMSActive() {
      axios
        .post("/patient-notifications/notify-sms", {'value': this.spaceParams.notify_sms})
        .then(response => {
          this.spaceParams.notify_sms = response.data.notify_sms;
          this.$store.dispatch("EDIT_NOTIFY_SMS", response.data.notify_sms);
        })
        .catch(() => {});
    }
  }
}
</script>